import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports--report"
export default class extends Controller {
  static targets = ["reportType", "axisRow"]

  connect() {
    this.syncForm()
  }

  syncForm() {
    const type = this.reportTypeTarget.value
    this.axisRowTarget.style.display = type === "daily" ? "" : "none"
  }
}
